(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui/reflection"), require("@bingads-webui/url-util"), require("@bingads-webui/registry"), require("@bingads-webui/edm-shared"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui/reflection", "@bingads-webui/url-util", "@bingads-webui/registry", "@bingads-webui/edm-shared"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui/reflection"), require("@bingads-webui/url-util"), require("@bingads-webui/registry"), require("@bingads-webui/edm-shared")) : factory(root["underscore"], root["@bingads-webui/reflection"], root["@bingads-webui/url-util"], root["@bingads-webui/registry"], root["@bingads-webui/edm-shared"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__39__, __WEBPACK_EXTERNAL_MODULE__42__, __WEBPACK_EXTERNAL_MODULE__47__, __WEBPACK_EXTERNAL_MODULE__48__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 85);
/******/ })
/************************************************************************/
/******/ ({

/***/ 39:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__39__;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__47__;

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__48__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(86);


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "resIdsPlugin", {
  enumerable: true,
  get: function get() {
    return _index.resIdsPlugin;
  }
});

var _index = __webpack_require__(87);

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resIdsPlugin = resIdsPlugin;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _reflection = __webpack_require__(39);

var url = _interopRequireWildcard(__webpack_require__(42));

var _registry = __webpack_require__(47);

var _edmShared = __webpack_require__(48);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * the Reource Identifier plugin for entity-data-model
 * @module component/edm-resource-identifiers/index
 */

/**
 * @param {EDM} edm - The EDM object to apply this plugin to
 * @return {Void} nothing to return
 */
function resIdsPlugin(edm) {
  if (edm.resourceIdentifiers) {
    return;
  }
  /**
   * @name edm
   * @property {Registry} resourceIdentifiers - A registry of all resource-identifiers
   * @property {Class} resourceIdentifiers.Navigation - The base type of all navigations
   * @property {Class} resourceIdentifiers.PropertyNavigation - The navigation following a property
   * @property {Class} resourceIdentifiers.CastNavigation - The navigation following a type casting
   * @property {Class} resourceIdentifiers.WithKeyNavigation
   * - The navigation of selecting a single instance from an entity set
   * @property {Class} resourceIdentifiers.CallNavigation - The navigation of calling a callable
   * @property {Class} resourceIdentifiers.ResourceIdentifier
   * - The base type of all resource-identifiers
   */


  (0, _reflection.defineConstProperty)(edm, 'resourceIdentifiers', (() => {
    const resourceIdentifiers = new _registry.Registry();
    const Navigation = (0, _edmShared.createNavigation)();
    /**
     * @class PropertyNavigation
     * @extends Navigation
     * @property {Property} property - The property navigated with
     */

    class PropertyNavigation extends Navigation {
      constructor({
        source,
        property,
        name
      }) {
        super({
          source
        });
        (0, _reflection.defineConstProperty)(this, 'property', property);
        (0, _reflection.defineConstProperty)(this, 'name', name);
        (0, _reflection.defineConstProperty)(this, 'path', url.join(source.path, name));
      }

      toSelfJSON() {
        return {
          type: 'property',
          name: this.name
        };
      }

      static defineOn(TypeResID, navigationProperties) {
        _underscore.default.each(navigationProperties, (property, name) => {
          /**
           * Navigation property factory for the defined property
           * @memberof TypeResID#
           * @this TypeResID
           * @returns {ResourceIdentifier} The ResourceIdentifier to access the property
           */
          function navPropFactory() {
            return new property.type.ResourceIdentifier({
              navigation: new PropertyNavigation({
                source: this,
                property,
                name
              })
            });
          }

          (0, _reflection.defineProducedPropertyOnClass)(TypeResID, name, navPropFactory);
        });
      }

    }

    class CallableNavigation extends Navigation {
      constructor({
        source,
        name
      }) {
        super({
          source
        });
        (0, _reflection.defineConstProperty)(this, 'name', name);
        (0, _reflection.defineConstProperty)(this, 'path', url.join(source.path, name));
      }

      static defineOn(TypeResID, callable) {
        function defineCallableOn(resID, callableTypes) {
          _underscore.default.each(callableTypes, type => {
            /**
             * factory for the callables
             * @memberof resID#
             * @this resID
             * @returns {ResourceIdentifier} The ResourceIdentifier to access the property
             */
            function factory() {
              return new type.ResourceIdentifier({
                navigation: new CallableNavigation({
                  source: this,
                  name: type.callableName
                })
              });
            }

            (0, _reflection.defineProducedPropertyOnClass)(resID, type.callableName, factory);
          });
        }

        defineCallableOn(TypeResID, callable.actions);
        defineCallableOn(TypeResID, callable.functions);
      }

    }

    const CastNavigation = (0, _edmShared.createCastNavigation)(Navigation, url, edm);
    const WithKeyNavigation = (0, _edmShared.createWithKeyNavigation)(Navigation);
    const CallNavigation = (0, _edmShared.createCallNavigation)(Navigation, edm);
    const ResourceIdentifier = (0, _edmShared.createResourceIdentifier)();
    /**
     * @class CollectionResourceIdentifier
     * @property {Navigation} navigation
     * - The navigation back tracking the parent ResourceIdentifier
     */

    class CollectionResourceIdentifier extends ResourceIdentifier {
      /**
       * Create a ResourceIdentifier
       * @param {Object} [options] - The constructor options
       * @param {Navigation} [options.navigation]
       * - The navigation back tracking the parent ResourceIdentifier
       * @return {Void} Nothing to return
       */
      constructor({
        navigation
      } = {}) {
        super({
          navigation
        });
      }

    }
    /**
     * define ResourceIdentifier type for the given type
     * @param {Type} type - An instance of one of the meta types
     * @return {Class} the ResourceIdentifier class
     */


    function resourceIdentifierForType(type) {
      // duck type, if the type has a "baseType", use its ResourceIdentifier as the super class
      const DefaultBase = type instanceof edm.types.CollectionType ? CollectionResourceIdentifier : ResourceIdentifier;
      const Base = type.baseType ? type.baseType.ResourceIdentifier : DefaultBase;
      const AccessorType = class extends Base {};
      /**
       * @name resId
       * @type ResourceIdentifier
       * @property {Type} type - The type associated with the ResourceIdentifier
       */

      (0, _reflection.defineConstProperty)(AccessorType.prototype, 'type', type);
      resourceIdentifiers.register(AccessorType, type.name);
      return AccessorType;
    } // For each of the meta types defined by the type mixin, define the
    // "ResourceIdentifier" property


    _underscore.default.each({
      // the root class 'Type' don't have an ResourceIdentifier property
      // Type: { factory() { } },
      PrimitiveType: {
        /**
         * PrimitiveType ResourceIdentifier type factory
         * @memberof PrimitiveType#
         * @this PrimitiveType
         * @returns {Class} The ResourceIdentifier type of the PrimitiveType
         */
        factory() {
          const PrimitiveTypeResID = resourceIdentifierForType(this);
          return PrimitiveTypeResID;
        }

      },
      ObjectType: {
        /**
         * ObjectType ResourceIdentifier type factory
         * @memberof ObjectType#
         * @this ObjectType
         * @returns {Class} The ResourceIdentifier type of the ObjectType
         */
        factory() {
          const ObjectTypeResID = resourceIdentifierForType(this);
          CastNavigation.defineOn(ObjectTypeResID);
          PropertyNavigation.defineOn(ObjectTypeResID, this.navigationProperties);

          if (this.callable) {
            CallableNavigation.defineOn(ObjectTypeResID, this.callable);
          }

          return ObjectTypeResID;
        }

      },
      // fallback to ObjectType.prototype.ResourceIdentifier
      // EntityType: { factory () { } },
      // fallback to ObjectType.prototype.ResourceIdentifier
      // ComplexType: { factory () { } },
      CollectionType: {
        /**
         * CollectionType ResourceIdentifier type factory
         * @memberof CollectionType#
         * @this CollectionType
         * @returns {Class} the ResourceIdentifier type of the CollectionType
         */
        factory() {
          const CollectionTypeResID = resourceIdentifierForType(this);
          CastNavigation.defineOn(CollectionTypeResID); // Only the entity sets can be navigated with keys

          if (this.elementType instanceof edm.types.EntityType) {
            WithKeyNavigation.defineOn(CollectionTypeResID);
          }

          PropertyNavigation.defineOn(CollectionTypeResID, this.navigationProperties);

          if (this.callable) {
            CallableNavigation.defineOn(CollectionTypeResID, this.callable);
          }

          return CollectionTypeResID;
        }

      },
      CallableType: {
        /**
         * CallableType ResourceIdentifier type factory
         * @memberof CallableType#
         * @this CallableType
         * @returns {Class} The ResourceIdentifier type of the CallableType
         */
        factory() {
          const CallableTypeResID = resourceIdentifierForType(this);
          CallNavigation.defineOn(CallableTypeResID);
          return CallableTypeResID;
        }

      }
    }, (def, typeName) => {
      /**
       * @name type
       * @type Type
       * @property {Class} ResourceIdentifier - The ResourceIdentifier type of the type
       */
      (0, _reflection.defineProducedPropertyOnClass)(edm.types[typeName], 'ResourceIdentifier', def.factory);
    });

    _underscore.default.chain(resourceIdentifiers).defineConstProperty('ResourceIdentifier', ResourceIdentifier).defineConstProperty('CollectionResourceIdentifier', CollectionResourceIdentifier).defineConstProperty('Navigation', Navigation).defineConstProperty('PropertyNavigation', PropertyNavigation).defineConstProperty('CastNavigation', CastNavigation).defineConstProperty('WithKeyNavigation', WithKeyNavigation).defineConstProperty('CallNavigation', CallNavigation).defineConstProperty('CallableNavigation', CallableNavigation).value();

    return resourceIdentifiers;
  })());
}

/***/ })

/******/ });
});
